export const DEPT_OPTION = [
  // { value: '', label: 'Bỏ chọn' },
  { value: 'NCC_THUCTE', label: 'CN NCC thực tế' },
  { value: 'NCC_NGAYPHATHANGTHUCTE', label: 'CN NCC theo ngày phát hàng thực tế' },
  { value: 'NCC_NGAYDATHANGTHUCTE', label: 'CN NCC theo ngày đặt hàng thực tế' },
  { value: 'NCCVC', label: 'Công nợ vận chuyển' },
  { value: 'NCCTIENTE', label: 'Công nợ thanh toán' },
  { value: 'NCCTHUE', label: 'Công nợ thuế' },
  
]


export const balanceOfdebtType = {
  NCC_THUCTE: "NCC_THUCTE",
  NCC_NGAYPHATHANGTHUCTE: "NCC_NGAYPHATHANGTHUCTE",
  NCC_NGAYDATHANGTHUCTE: "NCC_NGAYDATHANGTHUCTE",
  NCCVC: "NCCVC",
  NCCTIENTE: "NCCTIENTE",
  NCCTHUE: "NCCTHUE",
}

export const slug = {
  NCC_THUCTE: "congno-ncc-thucte",
  NCC_NGAYPHATHANGTHUCTE: "congno-ncc-phathang",
  NCC_NGAYDATHANGTHUCTE: "congno-ncc-dathang",
  NCCVC: "congno-ncc-vanchuyen",
  NCCTIENTE: "congno-ncc-tiente",
  NCCTHUE: "congno-ncc-thue",
}

/** Map loại sổ → quyền menu Công nợ */
export const congNoPermissionByType: Record<string, {
  list: string
  detail: string
  chot: string
  export: string
  exportDetail: string
}> = {
  NCC_THUCTE: {
    list: 'WEB_CONGNO_THUCTE_LIST',
    detail: 'WEB_CONGNO_THUCTE_DETAIL',
    chot: 'WEB_CONGNO_THUCTE_CHOT',
    export: 'WEB_CONGNO_THUCTE_EXPORT',
    exportDetail: 'WEB_CONGNO_THUCTE_EXPORT_DETAIL',
  },
  NCC_NGAYPHATHANGTHUCTE: {
    list: 'WEB_CONGNO_PHATHANG_LIST',
    detail: 'WEB_CONGNO_PHATHANG_DETAIL',
    chot: 'WEB_CONGNO_PHATHANG_CHOT',
    export: 'WEB_CONGNO_PHATHANG_EXPORT',
    exportDetail: 'WEB_CONGNO_PHATHANG_EXPORT_DETAIL',
  },
  NCC_NGAYDATHANGTHUCTE: {
    list: 'WEB_CONGNO_DATHANG_LIST',
    detail: 'WEB_CONGNO_DATHANG_DETAIL',
    chot: 'WEB_CONGNO_DATHANG_CHOT',
    export: 'WEB_CONGNO_DATHANG_EXPORT',
    exportDetail: 'WEB_CONGNO_DATHANG_EXPORT_DETAIL',
  },
  NCCVC: {
    list: 'WEB_CONGNO_VANCHUYEN_LIST',
    detail: 'WEB_CONGNO_VANCHUYEN_DETAIL',
    chot: 'WEB_CONGNO_VANCHUYEN_CHOT',
    export: 'WEB_CONGNO_VANCHUYEN_EXPORT',
    exportDetail: 'WEB_CONGNO_VANCHUYEN_EXPORT_DETAIL',
  },
  NCCTIENTE: {
    list: 'WEB_CONGNO_TIENTE_LIST',
    detail: 'WEB_CONGNO_TIENTE_DETAIL',
    chot: 'WEB_CONGNO_TIENTE_CHOT',
    export: 'WEB_CONGNO_TIENTE_EXPORT',
    exportDetail: 'WEB_CONGNO_TIENTE_EXPORT_DETAIL',
  },
  NCCTHUE: {
    list: 'WEB_CONGNO_THUE_LIST',
    detail: 'WEB_CONGNO_THUE_DETAIL',
    chot: 'WEB_CONGNO_THUE_CHOT',
    export: 'WEB_CONGNO_THUE_EXPORT',
    exportDetail: 'WEB_CONGNO_THUE_EXPORT_DETAIL',
  },
}

export const convertSlugToType = (loaiDoiTuong: string) => {
  switch (loaiDoiTuong) {
    case slug.NCC_THUCTE:
      return balanceOfdebtType.NCC_THUCTE
    case slug.NCC_NGAYPHATHANGTHUCTE:
      return balanceOfdebtType.NCC_NGAYPHATHANGTHUCTE
    case slug.NCC_NGAYDATHANGTHUCTE:
      return balanceOfdebtType.NCC_NGAYDATHANGTHUCTE
    case slug.NCCVC:
      return balanceOfdebtType.NCCVC
    case slug.NCCTIENTE:
      return balanceOfdebtType.NCCTIENTE
      case slug.NCCTHUE:
        return balanceOfdebtType.NCCTHUE
    default:
      return ""
  }
}
export const convertTypeToSlug = (loaiDoiTuong: string) => {
  switch (loaiDoiTuong) {
    case balanceOfdebtType.NCC_THUCTE:
      return slug.NCC_THUCTE
    case balanceOfdebtType.NCC_NGAYPHATHANGTHUCTE:
      return slug.NCC_NGAYPHATHANGTHUCTE
    case balanceOfdebtType.NCC_NGAYDATHANGTHUCTE:
      return slug.NCC_NGAYDATHANGTHUCTE
    case balanceOfdebtType.NCCVC:
      return slug.NCCVC
    case balanceOfdebtType.NCCTIENTE:
      return slug.NCCTIENTE
      case balanceOfdebtType.NCCTHUE:
        return slug.NCCTHUE
    default:
      return ""
  }
}




